import { render, staticRenderFns } from "./PracticaFin.vue?vue&type=template&id=56600faa&"
import script from "./PracticaFin.vue?vue&type=script&lang=js&"
export * from "./PracticaFin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports